// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"0c0e75a3","453":"d8ffcf55"}[chunkId] + ".chunk.js";
};